<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Contatti', route: '/backoffice/contatti/' }, { label: 'Modifica contatto', active: true }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formContatti" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Dati</h2>
        </div>

        <div class="fld">
            <label>* Titolo</label>
            <input type="text" pInputText class="w-full" placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formContatti.get('titolo')?.hasError('required') && (formContatti.get('titolo')?.dirty || formContatti.get('titolo')?.touched)">Il titolo è obbligatorio.</small>
        </div>

        <div class="fld">
            <label>* Descrizione</label>
            <p-editor [style]="{ height: '150px' }" formControlName="descrizione" (ngModelChange)="onDescrizione($event)" />
            <small class="text-red-600 block mt-2 font-medium" *ngIf="formContatti.get('descrizione')?.hasError('required') && (formContatti.get('descrizione')?.dirty || formContatti.get('descrizione')?.touched)">La descrizione è obbligatoria.</small>
        </div>

        <div class="acc-actions">
            <button class="acc-btn acc-btn-ghost" type="button" (click)="onDeleteContattoPopup($event)">Elimina contatto</button>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formContatti.valid">Salva modifiche</button>
        </div>

        <p-confirmPopup #confirmDeletePopupRef>
            <ng-template pTemplate="headless" let-message>
                <div class="border-round p-3">
                    <span class="text-base">{{ message.message }}</span>
                    <div class="flex align-items-center gap-2 mt-3">
                        <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>
                        <button type="button" class="acc-btn acc-btn-ghost flex-1" (click)="onAnnulla()">Annulla</button>
                    </div>
                </div>
            </ng-template>
        </p-confirmPopup>
    </form>
</section>
